import React, {useEffect} from 'react';
import {navigate} from '@reach/router';
import SalesIndex from '../join';

export default function (props) {
  useEffect(() => {
    navigate('/a-l/join-health/' + location.search);
  }, []);
  return (
    <SalesIndex noFixedVideo noExitIntent ctaNoTimer ctaOverride="joinSales" variant="ad" bucketOverride="health" />
  );
}
